import { Badge } from "@/components/ui/badge";
import type {
	PartnerBillingMode,
	PartnerTeamSummary,
} from "@/types/partner.types";

interface ClientStatusBadgeProps {
	client: Pick<PartnerTeamSummary, "blocked" | "isActive">;
}

export const ClientStatusBadge = (props: ClientStatusBadgeProps) => {
	const { client } = props;

	if (client.blocked) {
		return (
			<Badge className="border-0 bg-amber-500/10 text-amber-400">
				Pending activation
			</Badge>
		);
	}
	if (!client.isActive) {
		return (
			<Badge className="border-0 bg-clyr-gray-500/20 text-clyr-gray-300">
				Inactive
			</Badge>
		);
	}
	return (
		<Badge className="border-0 bg-green-500/10 text-green-400">Active</Badge>
	);
};

interface BillingModeBadgeProps {
	mode: PartnerBillingMode | null;
}

export const BillingModeBadge = (props: BillingModeBadgeProps) => {
	const { mode } = props;

	if (mode === "partner") {
		return (
			<Badge className="border-0 bg-clyr-blue-500/10 text-clyr-blue-400">
				Partner pays
			</Badge>
		);
	}
	if (mode === "client") {
		return (
			<Badge className="border-0 bg-orange-500/10 text-orange-400">
				Client pays
			</Badge>
		);
	}
	return (
		<Badge className="border-0 bg-clyr-gray-500/20 text-clyr-gray-300">—</Badge>
	);
};
